<template>
    <v-app>
        <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
        <v-card class="grlCardInfo">
            <v-breadcrumbs :items="obtRuta" class="grlClase">
                <template v-slot:item="{ item }">
                    <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
                        {{ item.text.toUpperCase() }}
                    </v-breadcrumbs-item>
                </template>
            </v-breadcrumbs>
        </v-card>
        <!--IMAGEN Y TITULO DE LA PÁGINA-->
        <v-card>
            <v-img :src="imgTitle" class="grlCardImg">
                <div class="grlCardInfo">
                    <h1 class="my-auto hidden-sm-and-down">Ingeniero Agrónomo Zootecnista</h1>
                </div>
            </v-img>
        </v-card>
        <!---->
        <div class="gralMargenes" id="gralEspaciado" style="text-align: justify">
            <hr />
            <h4 class="gralTitulosLic">Descripción</h4>
            <div class="p-4">
                <p>
                    Año de inicio de la Carrera de Ingeniero Agrónomo Zootecnista: 1972. (38 años)
                    <br>
                    El nuevo enfoque de la carrera de IAZ incorpora las siguientes consideraciones:
                </p>
                <ul>
                    <li>La reducción de la pobreza, como agente de cambio que coadyuvará en la satisfacción de las
                        necesidades
                        de aprendizaje básicas de la población rural, particularmente el desarrollo de habilidades y
                        destrezas
                        necesarias para la vida rural.</li>
                    <li>Se considera prioritario incorporar a los programas de estudio la educación ambiental y la toma de
                        conciencia en relación con la sostenibilidad de los patrones de consumo actuales.</li>
                    <li>El mejoramiento de los servicios a los agricultores, y capacidad para ofrecerlos a los grandes
                        negocios
                        agroindustriales.</li>
                    <li>Un nuevo modelo educativo, basado en la flexibilidad, en la formación integral, en la movilidad e
                        internacionalización y en un sistema de créditos.</li>
                </ul>
                <br>
                <!-- NEWS TABLE 2 -->
                <span class="title"><strong>Objetivos institucionales</strong></span>
                <hr>
                <p>
                <ul>
                    <li>Formar integralmente profesionales en agronomía y zootecnia altamente competitivos, con
                        profundos valores éticos que propendan al desarrollo sostenible de la producción
                        agropecuaria y/o industrial.</li>
                    <li>Generar nuevos conocimientos en el ámbito de la ciencia agronómica y la Zootecnia, a
                        través de la investigación básica y aplicada.</li>
                    <li>Vinculación permanente con productores del sector agropecuario, a través de la
                        transferencia y apropiación de tecnología.</li>
                    <li>Fomentar el servicio a las comunidades rurales a través de las prácticas profesionales y
                        el servicio social.</li>
                    <li>Difundir la cultura hacia la comunidad, de modo de contribuir al fortalecimiento de la
                        identidad regional.</li>
                </ul>
                </p>
            </div>
            <h4 class="gralTitulosLic">Más Infromación</h4>
            <v-card class="grlCardLic">
                <v-tabs>
                    <v-tabs-slider color="yellow"></v-tabs-slider>
                    <v-tab>Misión</v-tab>
                    <v-tab>Visión</v-tab>
                    <v-tab>Meta</v-tab>
                    <v-tab>Perfil de Ingreso</v-tab>
                    <v-tab>Perfil de Egreso</v-tab>
                    <v-tab>Plan de Estudios</v-tab>
                    <!--MISION-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <p>
                                Formar IAZ con un elevado espíritu emprendedor y de servicio al sector rural, dentro de un
                                ambiente plural y de excelencia académica, con conocimientos científicos, tecnológicos,
                                innovadores y creativos que les permitirá enfrentar competitivamente las demandas del
                                mercado laboral, sirviendo como vector para elevar la productividad agropecuaria del país y
                                de la región, con un enfoque de sustentabilidad y de equidad social. Y en una continua
                                vinculación con los diversos productores agropecuarios a través programas innovadores
                                educativos, de investigación, difusión y extensión.
                            </p>
                        </v-container>
                    </v-tab-item>
                    <!--VISION-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <p>
                                Ser en el 2010 un programa educativo pertinente, de alta calidad, acreditado y certificado
                                por los CIEES y el COMEAA, que aportará al conocimiento y promoverá el desarrollo rural
                                sustentable de la región, del estado y del país. Con liderazgo en su ámbito de acción en la
                                formación de IAZ con alto nivel académico, científico y tecnológico, y profundos valores
                                éticos.
                            </p>
                        </v-container>
                    </v-tab-item>
                    <!--META-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <ul>
                                <li>Constituir una oferta pertinente y de alta calidad educativa.</li>
                                <li>Aportar al conocimiento y promover el desarrollo sustentable de la región, del estado y
                                    del país.</li>
                                <li>Inculcar al futuro IAZ la utilización de las mejores tecnologías de vanguardia en la
                                    producción agropecuaria, acordes con las capacidades productivas del entorno, sin
                                    comprometer la conservación del medio ambiente, y con equidad social.</li>
                                <li>Fortalecer la vinculación con los diversos productores agropecuarios mediante programas
                                    innovadores educativos, de investigación, difusión y extensión.</li>
                            </ul>
                        </v-container>
                    </v-tab-item>
                    <!--PERFIL DE INGRESO-->
                    <v-tab-item class="p-4">
                        <!--PERFIL DE INGRESO-->
                        <v-container>
                            <span class="title">
                                <strong>PERFIL Y REQUISITOS DE INGRESO</strong>
                            </span>
                            <br>
                            <br>
                            <p>
                                El aspirante que desee ingresar a la carrera de Ingeniero Agrónomo Zootecnista deberá
                                cumplir con los siguientes requisitos:
                            </p>
                            <ul>
                                <li>Bachillerato general, o Bachillerato en físico químico matemático, o en ciencias
                                    biológicas.</li>
                                <li>Los estudiantes mexicanos deberán demostrar su nacionalidad con el documento
                                    correspondiente.</li>
                                <li>En el caso de estudiantes extranjeros además deberán demostrar su permanencia legal en
                                    el país, con copia certificada de los documentos correspondientes.</li>
                                <li>Demostrar mediante certificado médico su estado de salud.</li>
                            </ul>
                            <br>
                            <p> Además deberá poseer las siguientes características: </p>
                            <ul>
                                <li>Hábitos de estudio. Es fundamental la disciplina, dedicación y motivación hacia el
                                    estudio y la lectura dentro y fuera del aula.</li>
                                <li>Valores y actitudes: Honestidad, ética, seriedad, responsabilidad, iniciativa, respeto
                                    así mismo y a los demás.</li>
                                <li>Intereses y motivaciones. Interés en mantener contacto con la naturaleza, atracción por
                                    las actividades que se desarrollan al aire libre y capacidad para comprender fenómenos
                                    biológicos y sociales.</li>
                                <li>Expectativas sobre la formación y la práctica profesional. Habilidades para desarrollar
                                    labores de campo, relacionarse con el sector agropecuario, desempeñarse
                                    satisfactoriamente en el medio productivo e identificarse con el mismo.</li>
                            </ul>
                            <br>
                            <br>
                            <!-- NEWS TABLE 2 -->
                            <span class="subtitle"><strong>REQUISITOS DE INGRESO</strong></span>
                            <hr>
                            <p>
                                El aspirante a cursar el programa de estudios de la carrera de Ingeniero Agrónomo
                                Zootecnista en la Facultad de Agricultura y Zootecnia deberá presentar la siguiente
                                documentación de acuerdo al artículo 39 del Reglamento General de la Universidad Juárez del
                                Estado de Durango.
                            </p>
                            <br>
                            <ul>
                                <li>Llenar la solicitud de inscripción correspondiente.</li>
                                <li>6 Fotografías tamaño infantil de frente en blanco y negro o a color.</li>
                                <li>Certificado original de enseñanza secundaria y dos copias.</li>
                                <li>Certificado o Constancia original de enseñanza preparatoria y dos fotocopias.</li>
                                <li>Certificado de salud reciente de dependencia oficial (IMSS, ISSSTE, SSA,).</li>
                                <li>Carta de antecedentes no penales.</li>
                                <li>Acta de nacimiento certificada original y dos fotocopias.</li>
                                <li>Aprobar requisitos de admisión.</li>
                                <li>Pagar ficha examen diagnostico.</li>
                                <li>Pagar inscripción al 1er Semestre.</li>
                            </ul>
                        </v-container>
                    </v-tab-item>
                    <!--PERFIL DE EGRESO-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <span class="title">
                                <strong>PERFIL Y REQUISITOS DE EGRESO</strong>
                            </span>
                            <br>
                            <br>
                            <p>
                                El Ingeniero Agrónomo Zootecnista de la Facultad de Agricultura y Zootecnia de la
                                Universidad Juárez del Estado de Durango será capaz de incrementar la productividad de los
                                ecosistemas agropecuarios, con base en los conceptos de sustentabilidad y desarrollo de la
                                sociedad, buscando con ello satisfacer la demanda alimenticia del país. Mediante la
                                aplicación de técnicas relacionadas con la cría, manejo y alimentación de los animales
                                domésticos útiles y de importancia cinegética para el hombre, y la transformación e
                                industrialización de los productos pecuarios. Asimismo con la aplicación de fundamentos
                                administrativos e innovadores que contribuyan a la obtención de producciones económicamente
                                rentables y respetuosas del medio ambiente. Además estará capacitado para desarrollar las
                                siguientes competencias profesionales:
                            </p>
                            <br>
                            <ul>
                                <li>Diseñar, organizar y dirigir sistemas de producción aplicando tecnologías y procesos que
                                    mejoren la productividad agropecuaria a nivel regional, nacional e internacional, de una
                                    forma ética, creativa, crítica, solidaria y sustentable.</li>
                                <li>Analizar los procesos de conservación e industrialización de productos agrícolas y
                                    pecuarios para mantener y mejorar la calidad, generando valor agregado, con
                                    responsabilidad y oportunidad, en congruencia con la normatividad ambiental y el
                                    desarrollo sustentable.</li>
                                <li>Revisar y evaluar las tendencias de precios y mercados de los productos agropecuarios a
                                    partir de indicadores económicos regionales, nacionales e internacionales, que permitan
                                    generar condiciones para el mejoramiento de la competitividad, que coadyuve al
                                    desarrollo económico del país, con sentido social, objetividad y de pertinencia.</li>
                                <li>Evaluar y/o aplicar procedimientos de administración en las empresas agropecuarias y/o
                                    sector oficial, a nivel local, estatal y nacional, usando estrategias de optimización de
                                    recursos para incrementar la productividad, impactando el desarrollo agropecuario del
                                    país, con honestidad, responsabilidad y eficiencia.</li>
                                <li>Validar e interpretar información sobresaliente aplicando el método científico en los
                                    sistemas de producción, conservación industrialización y comercialización, con visión
                                    holística, ética y sustentable.</li>
                            </ul>
                            <br>
                            <br>
                            <!-- NEWS TABLE 2 -->
                            <span class="subtitle"><strong>REQUISITOS DE EGRESO</strong></span>
                            <hr>
                            <ul>
                                <li>Haber cumplido satisfactoriamente con el número mínimo de créditos, establecido en el
                                    reglamento del programa.</li>
                                <li>Haber cumplido con el servicio social.</li>
                                <li>Acreditar sus prácticas profesionales.</li>
                                <li>Acreditar el nivel de ingles que marca el programa.</li>
                                <li>No tener adeudos en biblioteca, laboratorios, talleres y postas.</li>
                                <li>El grado académico se obtendrá mediante examen profesional en concordancia con lo
                                    estipulado por el Reglamento General de la UJED.</li>
                            </ul>
                        </v-container>
                    </v-tab-item>
                    <!--PLAN DE ESTUDIOS-->
                    <v-tab-item class="p-4">
                        <v-container>
                            <v-img :src="imgReticula"></v-img>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </div>
    </v-app>
</template>
<script>

export default {
    data: () => ({
        img: require('../../assets/img/logo_ujed.png'),
        imgReticula: require('../../assets/img/plan-estudios-zootecnista.jpg'),
        imgTitle: require('../../assets/img/banner-OE.jpg'),
        obtRuta: [
            {
                text: 'Inicio',
                disabled: false,
                ruta: '/',
            },
            {
                text: 'Oferta Educativa',
                disabled: true,
                ruta: '/',
            },
            {
                text: 'Licenciaturas',
                disabled: false,
                ruta: '/licenciaturas',
            },
            {
                text: '',
                disabled: true,
                ruta: '/licenciaturas',
            },
        ],
    }),
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
};
</script>
    